import variant from 'apps/acp/variants/www.netspendskylight.com';
import { createBehaviorSubject } from 'packages/behavior-subject';

import { startGateway } from 'apps/acp/gateway';
import { mapVariantToAcpEnv } from 'apps/acp/gateway/map-variant';

const mappedVariantEnv = mapVariantToAcpEnv(variant);


startGateway(mappedVariantEnv);
